import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da63bc76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-error" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://support.polkadot.network/support/solutions/articles/65000168651-what-is-the-existential-deposit-#:~:text=Print&text=On%20the%20Polkadot%20network%2C%20an,the%20Existential%20Deposit%20(ED)." }, "What is Existential Limit?")
], -1))

import AlertIcon from "@/icons/common/alert-icon.vue";
import { nativeToken } from "@/stores";
import { Token } from "@/types/token";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'send-error',
  props: {
  token: {
    type: Object as PropType<Token>,
    default: nativeToken.value,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AlertIcon),
    _createElementVNode("p", null, [
      _createTextVNode(" If you send this transaction your balance will drop below the Existential Limit of " + _toDisplayString(__props.token?.existentialDeposit?.toString()) + " ", 1),
      _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1),
      _createTextVNode(". This will cause your remaining balance to drop to 0 "),
      _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1),
      _createTextVNode(". ")
    ]),
    _hoisted_2
  ]))
}
}

})